import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { profileApi } from '../lib/api'
import type { UpdateProfileRequest } from '../types/profile'

export function useProfile() {
  return useQuery({
    queryKey: ['profile'],
    queryFn: () => profileApi.get().then(r => r.data),
  })
}

export function useUpdateProfile() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: UpdateProfileRequest) =>
      profileApi.update(data).then(r => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] })
    },
  })
}

export function useUploadProfilePortrait() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (file: File) =>
      profileApi.uploadPortrait(file).then(r => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] })
    },
  })
}

export function useDeleteProfilePortrait() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => profileApi.deletePortrait(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] })
    },
  })
}
